import Dexie, { type EntityTable } from 'dexie';
import { normalizeDocument, type ShpeshftDocument } from '../core/document';

type StoredProject = { id: string; updatedAt: string; document: ShpeshftDocument };

const database = new Dexie('shpeshft') as Dexie & { projects: EntityTable<StoredProject, 'id'> };
database.version(1).stores({ projects: 'id, updatedAt' });

export async function saveProject(document: ShpeshftDocument): Promise<void> {
  await database.transaction('rw', database.projects, () => database.projects.put({ id: document.id, updatedAt: document.updatedAt, document }));
}

export async function loadLatestProject(): Promise<ShpeshftDocument | null> {
  const project = await database.projects.orderBy('updatedAt').last();
  return project?.document ? normalizeDocument(project.document) : null;
}

export async function loadProjects(): Promise<ShpeshftDocument[]> {
  const projects = await database.projects.orderBy('updatedAt').reverse().toArray();
  return projects.map(({ document }) => normalizeDocument(document));
}

export async function deleteProject(id: string): Promise<void> {
  await database.projects.delete(id);
}

export async function duplicateProject(source: ShpeshftDocument): Promise<ShpeshftDocument> {
  const now = new Date().toISOString();
  const document = normalizeDocument(structuredClone({ ...source, id: crypto.randomUUID(), title: `${source.title} copy`, createdAt: now, updatedAt: now }));
  await saveProject(document);
  return document;
}
